import React, { useContext } from 'react';
import { Typography } from 'fronton-react';
import { DataContext } from 'entries/common/widgets/saved-project-configuration/context';
import { BasketLogicSnackbar } from 'pages/common/components/BasketLogicSnackbar';
import { AddToShoppingList } from '../../components/AddToShoppingList';
import { RoomParams } from '../../components/RoomParams';
import { AddToCart } from '../../components/AddToCart';
import { ProductsList } from '../../components/ProductsList';
import { useSavedProjectsCalculationState } from '../../store/calculation';
import { ServiceBanner } from './components/ServiceBanner';
import {
  FormContainer,
  ParamsHeaderContainer,
  CalculationFormRow,
  CalculationFormColumnLeft,
  CalculationFormColumnRight,
} from './styles';

export const Calculation = () => {
  const { data } = useContext(DataContext);
  const configurationParameters = data?.projectConfigurationParameters;
  const hasPresaleProps = Boolean(data?.presaleProps);
  useSavedProjectsCalculationState();

  return (
    <FormContainer noTopMargin={hasPresaleProps}>
      <ParamsHeaderContainer>
        <Typography variant="h2" color="text-primary" data-testid="saved-calculation-title">
          Сохранённый расчёт
        </Typography>
        {!__IS_SERVER__ && !hasPresaleProps ? <AddToShoppingList /> : null}
      </ParamsHeaderContainer>
      <CalculationFormRow>
        <CalculationFormColumnLeft>
          <ProductsList />
          <ServiceBanner />
        </CalculationFormColumnLeft>
        <CalculationFormColumnRight>
          {configurationParameters ? <RoomParams configurationParameters={configurationParameters} /> : null}
          <AddToCart />
        </CalculationFormColumnRight>
      </CalculationFormRow>
      <BasketLogicSnackbar />
    </FormContainer>
  );
};
